import { memo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { CopiedText } from 'shared/components/copiedText'

import { partnerEditorTranslation } from '../../translation'

import { IPartnerSummuryProps } from './models'

import styles from './PartnerSummury.module.scss'

export const PartnerSummury = memo<IPartnerSummuryProps>(({ partner }) => {
  return (
    <div className={styles.partnerSummury}>
      <div className={styles.partnerName}>{partner.communicationName}</div>
      <div className={styles.partnerAdditional}>
        <div>
          <div className={styles.label}>
            <Translation text={partnerEditorTranslation.header.partnerSummury.partnerId} span />
          </div>
          <div className={styles.value}>
            <CopiedText>{partner.partnerId}</CopiedText>
          </div>
        </div>
        <div>
          <div className={styles.label}>
            <Translation text={partnerEditorTranslation.header.partnerSummury.locationId} span />
          </div>
          <div className={styles.value}>
            <CopiedText>{partner.locationId}</CopiedText>
          </div>
        </div>
      </div>
    </div>
  )
})
